import { jargonZh } from "./jargon-zh";

const EVIDENCE_RE =
  /转写|口播|OCR|字幕|画面显示|画面中|帧|截图|\d+\.\d+\s*s|时间戳|视频中|原片/;

const SENTENCE_SPLIT_RE = /(?<=[。．!？;；\n])|(?<=\.(?!\d))/;

/**
 * 展示层净化器:把 spot 的 recommendation/reasoning 原文转成学习者可读文本。
 * 管线:按句切分 → 剔除证据句(生产痕迹) → jargonZh 换词 → 兜底回落。
 * 纯读时处理,绝不写回数据文件。
 */
export function teachText(raw: string | null | undefined): string {
  if (!raw) return "";

  const sentences = raw.split(SENTENCE_SPLIT_RE);
  const cleaned = sentences.filter((s) => !EVIDENCE_RE.test(s)).join("");

  const base = cleaned.trim() ? cleaned : raw;

  return jargonZh(base);
}
